import React, { FC } from 'react';

import { RenderElementProps } from 'slate-react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';

interface SurfaceButtonElementProps extends RenderElementProps {
    label?: string;
}

const SurfaceButtonElement: FC<SurfaceButtonElementProps> = ({
    attributes,
    children,
    label,
}) => {
    return (
        <div {...attributes}>
            <LabelText contentEditable={false}>{label}</LabelText>
            <ButtonContainer>{children}</ButtonContainer>
        </div>
    );
};

export default SurfaceButtonElement;

const ButtonContainer = styled.div({
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    padding: aampeTheme.spacing4(3),
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
});

const LabelText = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(1),
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.gray800,
    textTransform: 'capitalize',
    marginBottom: aampeTheme.spacing4(2),
});
